// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* 가로 모드 스타일 */
.HV_horizontal__ArCqQ {
  flex-direction: column !important;
}
.HV_horizontal__ArCqQ .HV_mainContent__Ca9G3 {
  height: 50% !important;
  width: 100% !important;
  min-height: 100px;
  overflow: auto !important;
}
.HV_horizontal__ArCqQ .HV_resizeHandle__dz5QY {
  height: 10px !important;
  width: 100% !important;
  cursor: row-resize;
  background-color: #f0f0f0;
  border-top: 1px solid #e0e0e0;
  border-bottom: 1px solid #e0e0e0;
  display: flex;
  justify-content: center;
  align-items: center;
}
.HV_horizontal__ArCqQ .HV_resizeHandle__dz5QY:before {
  content: "";
  width: 30px;
  height: 4px;
  background-color: #ccc;
  border-radius: 2px;
}
.HV_horizontal__ArCqQ .HV_resizeHandle__dz5QY:hover {
  background-color: #e0e0e0;
}
.HV_horizontal__ArCqQ .HV_detailContent__xIC\\+i {
  flex: 1 1;
  width: 100% !important;
  min-height: 100px;
  border-top: 1px solid #e0e0e0;
  overflow: hidden;
}

/* 세로 모드 스타일 */
.HV_vertical__3HUDz {
  flex-direction: row !important;
}
.HV_vertical__3HUDz .HV_mainContent__Ca9G3 {
  width: 50% !important;
  height: 100% !important;
  overflow: auto !important;
  flex-shrink: 0;
  /* 스크롤바 스타일 */
}
.HV_vertical__3HUDz .HV_mainContent__Ca9G3::-webkit-scrollbar {
  width: 8px !important;
  height: 8px !important;
  display: block !important;
}
.HV_vertical__3HUDz .HV_mainContent__Ca9G3::-webkit-scrollbar-track {
  background: transparent !important;
}
.HV_vertical__3HUDz .HV_mainContent__Ca9G3::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.2) !important;
  border-radius: 4px !important;
}
.HV_vertical__3HUDz .HV_mainContent__Ca9G3::-webkit-scrollbar-thumb:hover {
  background-color: rgba(0, 0, 0, 0.3) !important;
}
.HV_vertical__3HUDz .HV_resizeHandle__dz5QY {
  width: 10px !important;
  height: 100% !important;
  cursor: col-resize;
  background-color: #f0f0f0;
  border-left: 1px solid #e0e0e0;
  border-right: 1px solid #e0e0e0;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
}
.HV_vertical__3HUDz .HV_resizeHandle__dz5QY:before {
  content: "";
  width: 4px;
  height: 30px;
  background-color: #ccc;
  border-radius: 2px;
}
.HV_vertical__3HUDz .HV_resizeHandle__dz5QY:hover {
  background-color: #e0e0e0;
}
.HV_vertical__3HUDz .HV_detailContent__xIC\\+i {
  flex: 1 1;
  height: 100% !important;
  border-left: 1px solid #e0e0e0;
  overflow: hidden;
}

.HV_splitView__gCMd- {
  display: flex;
  height: 100%;
  overflow: hidden;
  position: relative;
}

.HV_mainContent__Ca9G3 {
  height: 70%; /* 기본 높이 70%로 설정 */
  min-height: 100px;
  overflow: auto !important;
}

.HV_resizeHandle__dz5QY {
  height: 10px;
  background-color: #f0f0f0;
  cursor: row-resize;
  display: flex;
  justify-content: center;
  align-items: center;
  -webkit-user-select: none;
          user-select: none;
}
.HV_resizeHandle__dz5QY:hover {
  background-color: #e0e0e0;
}
.HV_resizeHandle__dz5QY:before {
  content: "";
  width: 30px;
  height: 4px;
  background-color: #ccc;
  border-radius: 2px;
}

.HV_detailContent__xIC\\+i {
  flex: 1 1; /* 남은 공간을 모두 차지 */
  min-height: 100px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border-top: 1px solid #e0e0e0;
}

.HV_iframeContainer__H2P4Y {
  flex: 1 1;
  position: relative;
  background-color: #f5f5f5;
}

.HV_noSelection__C7FI3 {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  color: #999;
  font-size: 16px;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/pages/History/HV.module.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB,cAAA;AACA;EACE,iCAAA;AAEF;AAAE;EACE,sBAAA;EACA,sBAAA;EACA,iBAAA;EACA,yBAAA;AAEJ;AACE;EACE,uBAAA;EACA,sBAAA;EACA,kBAAA;EACA,yBAAA;EACA,6BAAA;EACA,gCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AACJ;AACI;EACE,WAAA;EACA,WAAA;EACA,WAAA;EACA,sBAAA;EACA,kBAAA;AACN;AAEI;EACE,yBAAA;AAAN;AAIE;EACE,SAAA;EACA,sBAAA;EACA,iBAAA;EACA,6BAAA;EACA,gBAAA;AAFJ;;AAMA,cAAA;AACA;EACE,8BAAA;AAHF;AAKE;EACE,qBAAA;EACA,uBAAA;EACA,yBAAA;EACA,cAAA;EAEA,aAAA;AAJJ;AAKI;EACE,qBAAA;EACA,sBAAA;EACA,yBAAA;AAHN;AAMI;EACE,kCAAA;AAJN;AAOI;EACE,+CAAA;EACA,6BAAA;AALN;AAOM;EACE,+CAAA;AALR;AAUE;EACE,sBAAA;EACA,uBAAA;EACA,kBAAA;EACA,yBAAA;EACA,8BAAA;EACA,+BAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;AARJ;AAUI;EACE,WAAA;EACA,UAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;AARN;AAWI;EACE,yBAAA;AATN;AAaE;EACE,SAAA;EACA,uBAAA;EACA,8BAAA;EACA,gBAAA;AAXJ;;AAeA;EACE,aAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;AAZF;;AAeA;EACE,WAAA,EAAA,kBAAA;EACA,iBAAA;EACA,yBAAA;AAZF;;AAeA;EACE,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBAAA;UAAA,iBAAA;AAZF;AAcE;EACE,yBAAA;AAZJ;AAeE;EACE,WAAA;EACA,WAAA;EACA,WAAA;EACA,sBAAA;EACA,kBAAA;AAbJ;;AAiBA;EACE,SAAA,EAAA,iBAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,6BAAA;AAdF;;AAiBA;EACE,SAAA;EACA,kBAAA;EACA,yBAAA;AAdF;;AAiBA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;AAdF","sourcesContent":["/* 가로 모드 스타일 */\n.horizontal {\n  flex-direction: column !important;\n  \n  .mainContent {\n    height: 50% !important;\n    width: 100% !important;\n    min-height: 100px;\n    overflow: auto !important;\n  }\n  \n  .resizeHandle {\n    height: 10px !important;\n    width: 100% !important;\n    cursor: row-resize;\n    background-color: #f0f0f0;\n    border-top: 1px solid #e0e0e0;\n    border-bottom: 1px solid #e0e0e0;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    \n    &:before {\n      content: '';\n      width: 30px;\n      height: 4px;\n      background-color: #ccc;\n      border-radius: 2px;\n    }\n    \n    &:hover {\n      background-color: #e0e0e0;\n    }\n  }\n  \n  .detailContent {\n    flex: 1;\n    width: 100% !important;\n    min-height: 100px;\n    border-top: 1px solid #e0e0e0;\n    overflow: hidden;\n  }\n}\n\n/* 세로 모드 스타일 */\n.vertical {\n  flex-direction: row !important;\n  \n  .mainContent {\n    width: 50% !important;\n    height: 100% !important;\n    overflow: auto !important;\n    flex-shrink: 0;\n    \n    /* 스크롤바 스타일 */\n    &::-webkit-scrollbar {\n      width: 8px !important;\n      height: 8px !important;\n      display: block !important;\n    }\n    \n    &::-webkit-scrollbar-track {\n      background: transparent !important;\n    }\n    \n    &::-webkit-scrollbar-thumb {\n      background-color: rgba(0, 0, 0, 0.2) !important;\n      border-radius: 4px !important;\n      \n      &:hover {\n        background-color: rgba(0, 0, 0, 0.3) !important;\n      }\n    }\n  }\n  \n  .resizeHandle {\n    width: 10px !important;\n    height: 100% !important;\n    cursor: col-resize;\n    background-color: #f0f0f0;\n    border-left: 1px solid #e0e0e0;\n    border-right: 1px solid #e0e0e0;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-shrink: 0;\n    \n    &:before {\n      content: '';\n      width: 4px;\n      height: 30px;\n      background-color: #ccc;\n      border-radius: 2px;\n    }\n    \n    &:hover {\n      background-color: #e0e0e0;\n    }\n  }\n  \n  .detailContent {\n    flex: 1;\n    height: 100% !important;\n    border-left: 1px solid #e0e0e0;\n    overflow: hidden;\n  }\n}\n\n.splitView {\n  display: flex;\n  height: 100%;\n  overflow: hidden;\n  position: relative;\n}\n\n.mainContent {\n  height: 70%; /* 기본 높이 70%로 설정 */\n  min-height: 100px;\n  overflow: auto !important;\n}\n\n.resizeHandle {\n  height: 10px;\n  background-color: #f0f0f0;\n  cursor: row-resize;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  user-select: none;\n  \n  &:hover {\n    background-color: #e0e0e0;\n  }\n  \n  &:before {\n    content: '';\n    width: 30px;\n    height: 4px;\n    background-color: #ccc;\n    border-radius: 2px;\n  }\n}\n\n.detailContent {\n  flex: 1; /* 남은 공간을 모두 차지 */\n  min-height: 100px;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  border-top: 1px solid #e0e0e0;\n}\n\n.iframeContainer {\n  flex: 1;\n  position: relative;\n  background-color: #f5f5f5;\n}\n\n.noSelection {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n  color: #999;\n  font-size: 16px;\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"horizontal": `HV_horizontal__ArCqQ`,
	"mainContent": `HV_mainContent__Ca9G3`,
	"resizeHandle": `HV_resizeHandle__dz5QY`,
	"detailContent": `HV_detailContent__xIC+i`,
	"vertical": `HV_vertical__3HUDz`,
	"splitView": `HV_splitView__gCMd-`,
	"iframeContainer": `HV_iframeContainer__H2P4Y`,
	"noSelection": `HV_noSelection__C7FI3`
};
export default ___CSS_LOADER_EXPORT___;
